/**
 * 主包BundleName
 */
export const MainPageBundleNameList = {
  PickUp: 'mach_pro_sailor_c_pick_up_page_main', //自提落地页
  Home: 'mach_pro_sailor_c_home_page_main', //首页
  QualitySpecial: 'mach_pro_sailor_c_quality_special_page_main', //品质专区落地页
  ShopFavorites: 'mach_pro_sailor_c_shop_favorites', // 收藏页,
  ChannelList: 'mach_pro_sailor_c_channel_list_main', //通用落地页
  FixedPrice: 'mach_pro_sailor_c_fixed_price', // 一人食落地页
  MealForOne: 'mach_pro_sailor_c_meal_for_one_main',
};

/**
 * 二级页头图组件列表
 */
export const MainPagePicBGList = ['mach_pro_sailor_c_common_header_bg_sub', 'mach_pro_sailor_c_channel_list_header_image_sub'];
